var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-root-container"},[_c('div',{staticClass:"page-title"},[_vm._v("已添加的服务")]),_c('tip-board',{staticStyle:{"margin-top":"50px","margin-right":"150px"},attrs:{"title":"当前没有外部服务","sub-title":"可能由于","source":_vm.icons.servicePlaceholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }